import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule, NavParams } from '@ionic/angular';

import { ConfigurationValuesRulingPage } from './configuration-values-ruling.page';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        PipesModule,
        MatTabsModule
    ],
    declarations: [
        ConfigurationValuesRulingPage
    ],
    providers: [
        NavParams
    ]
})
export class ConfigurationValuesRulingPageModule { }
